import { arrayOf, shape, string } from 'prop-types';
import React from 'react';
import ContentBundle from 'components/ContentBundle';
import SitePostLayout from 'components/SitePostLayout';

const BUNDLE_MAP = {
  post: SitePostLayout
};

function PostLayout(props) {
  const { contentBundles } = props;

  return (
    <div className="PostLayout">
      {contentBundles.map((bundle, idx) => (
        <ContentBundle
          key={bundle.id}
          idx={idx}
          components={BUNDLE_MAP}
          {...bundle}
        />
      ))}
    </div>
  );
}

PostLayout.defaultProps = {
  contentBundles: undefined
};

PostLayout.propTypes = {
  contentBundles: arrayOf(
    shape({
      id: string.isRequired
    })
  )
};

export default PostLayout;
